﻿import React, { useState, useEffect } from 'react';
import MethodColumnComponent from './MethodColumnComponent';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import { MethodDetail } from '../../models/Methods/method-detail';
import { CrudFunctions } from '../../utilities/crud-functions';
import { Method } from '../../models/Methods/method';
import { Gradient } from '../../models/Methods/gradient';
import { FieldUpdate } from '../../models/field-update';
import { TemperatureProgram } from '../../models/Methods/temperature-program';
import SolventsLookup from '../Solvents/SolventsLookup';
import { SolventConfiguration } from '../../models/Solvents/solvent-configuration';
import { ItemBasicInformation } from '../../models/item-basic-information';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { ToastProps } from '../../models/toast-props';

import TextBox from 'devextreme-react/text-box';
import SelectBox from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { Toast } from 'devextreme-react/toast';

let key = 0;

export interface Props {
    methodId: string;
    selectedMethod?: Method;
    readOnly: boolean;
}

export default function QnmrMethodDetailsComponent(props: Props) {
    const [methodDetail, setMethodDetail] =
        useState<MethodDetail>();

    const [solventLookupVisible, setSolventLookupVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>(false);

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getMethodDetails();
    }, [props.methodId]);

    //this is needed, otherwise Description gets overwritten by the previous value 
    useEffect(() => {
        setDataLoaded(true);
    }, [methodDetail]);

    key++;

    return (
        <div style={{ backgroundColor: '#d8eaf8' }} className="pw-padding-05 pw-margin-top-1" >

            <div className="pw-two-column-grid">
                <div>
                    <div>
                        <div className="pw-comp-row">

                            <div className="pw-form-unit pw-comp-15">
                                <div className="pw-form-unit-label">Acquisition Method</div>
                                <TextBox id="acquisitionMethod" className="textbox"
                                    onValueChanged={onValueChanged} disabled={props.readOnly}
                                    showClearButton={true} placeholder="NA"
                                    value={methodDetail && methodDetail.acquisitionMethod ? methodDetail.acquisitionMethod : undefined} />

                            </div>
                            <div className="pw-form-unit pw-comp-15">
                                <div className="pw-form-unit-label">Solvent Name</div>
                                <TextBox id="solventName" className="textbox" readOnly={true}
                                    disabled={props.readOnly}
                                    placeholder="NA"
                                    value={methodDetail && methodDetail.solventName ? methodDetail.solventName : undefined} />
                            </div>

                            <div className="pw-row-button-08">
                                <Button className="title-bar-button"
                                    text="" icon="search" type="success"
                                    hint="lookup solvent"
                                    onClick={showSolventsLookupDialog} />
                            </div>
                        </div>


                    </div>
                </div>
            </div>

            {solventLookupVisible &&
                <DialogPopup visible={solventLookupVisible}
                    onHiding={hideSolventsLookupDialog}
                    title="Solvent Lookup"
                    width='50vw'
                    height='50vh'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <SolventsLookup onApplySelection={onSolventsLookupApplySelection}
                        onCancel={hideSolventsLookupDialog}
                        key={`SL${key}`} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div >
    );

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && methodDetail) {
            const m = methodDetail as any;
            const currentValue = m[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                let fieldUpdate: FieldUpdate = {
                    field: caller,
                    value: e.value,
                    rowId: methodDetail.methodId
                };

                await updateMethodDetailField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Method Detail Field");
                    })
            }
        }

        setMethodDetail({ ...methodDetail, [caller]: e.value });
    }


    function onSolventsLookupApplySelection(solvent: SolventConfiguration) {

        //todo - save to database


        if (solvent && solvent.macolaSolvent) {
            let editedMethodDetail = { ...methodDetail };

            editedMethodDetail.solventName = solvent.macolaSolvent;

            setMethodDetail(editedMethodDetail);
            hideSolventsLookupDialog();
        }
        else {
            //show info dialog - "No solvent found"

        }
    }

    async function getMethodDetails() {
        if (props.methodId) {
            setDataLoaded(false);

            await CrudFunctions.getData(`methods/methoddetail/${props.methodId}`)
                .then(data => {
                    setMethodDetail(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Method Details");
                });
        }
    }


    async function updateMethodField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methodfield", fieldUpdate);
    }

    async function updateMethodDetailField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("methods/methoddetailfield", fieldUpdate);
    }

    async function getAllData() {
        // await getScanTypes().then(() => {
        setDataLoaded(true)
        // });
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showSolventsLookupDialog() {
        setSolventLookupVisible(true);
    }

    function hideSolventsLookupDialog() {
        setSolventLookupVisible(false);
    }


    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}